///////////////////////////////////////////
//////////////// NEWSLETTERS //////////////
//////////////////////////////////////////

document.addEventListener('DOMContentLoaded', function() {
  // --- Configuration ---
  // For each trigger, map a desktop and a mobile Klaviyo Form ID.
  const klaviyoTriggers = {
    '#Cinque': {
      desktop: 'TYDdhR',
      mobile: 'TYDdhR'
    },
    '#apparel-signup': {
      desktop: 'Uq7qVL',
      mobile: 'WKwHDP'
    },
    '#newsletter': {
      desktop: 'XqNN2b',
      mobile: 'RbF6NP'
    },
    '#team-sales': {
      desktop: 'VYdVPT',
      mobile: 'W9AETR'
    }
    // Add new triggers here, following the same format
  };
  // --------------------

  // Get all the keys (the hrefs like '#varsity-signup') from our configuration
  const triggerHrefs = Object.keys(klaviyoTriggers);

  // If there are no triggers defined, don't do anything else
  if (triggerHrefs.length === 0) {
    return;
  }

  // Create a CSS selector to find all links with any of our trigger hrefs
  // It will look like: a[href="#varsity-signup"],a[href="#apparel-signup"],...
  const selector = triggerHrefs.map(href => `a[href="${href}"]`).join(',');

  // Find all links on the page that match our selector
  const triggerLinks = document.querySelectorAll(selector);

  // Loop through each found link
  triggerLinks.forEach(function(link) {
    link.addEventListener('click', function(event) {
      // Prevent the link from trying to navigate anywhere
      event.preventDefault();

      // Check if the viewport matches mobile dimensions (at the time of the click)
      const isMobile = window.matchMedia('(max-width: 719px)').matches;

      // Get the href of the clicked link (e.g., '#varsity-signup')
      const clickedHref = link.getAttribute('href');

      // Find the corresponding config object from our configuration
      const triggerConfig = klaviyoTriggers[clickedHref];

      // If we have a valid config, choose the form ID based on the device type
      if (triggerConfig) {
        const formId = isMobile ? triggerConfig.mobile : triggerConfig.desktop;
        
        // If a form ID exists for the current device type, trigger the popup
        if (formId) {
          window._klOnsite = window._klOnsite || [];
          window._klOnsite.push(['openForm', formId]);
          console.log(`Klaviyo form ${formId} triggered by ${clickedHref} on ${isMobile ? 'mobile' : 'desktop'}.`);
        } else {
          console.log(`No ${isMobile ? 'mobile' : 'desktop'} form ID configured for ${clickedHref}.`);
        }
      }
    });
  });
});

